import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import phonakimg from "../../../img/new2.png";
import "../Products/Products.css";
import ReactPlayer from "react-player";
import saveimg from "../../../img/silde14.jpg";
import save2img from "../../../img/save2.png";
import save3img from "../../../img/save3.png";
import save4img from "../../../img/save22.jpg";
import save5img from "../../../img/Phonak-Naida-Paradise.jpg";
import save6img from "../../../img/silde15.jpg";
import sildeimg1 from "../../../img/silde22.png";
import sildeimg2 from "../../../img/silde23.png";
import sildeimg3 from "../../../img/silde24.jpg";
import sildeimg4 from "../../../img/silde25.png";
import sildeimg5 from "../../../img/silde26.png";
import sildeimg6 from "../../../img/silde27.png";
import sildeimg7 from "../../../img/silde28.png";
import sildeimg9 from "../../../img/silde16.jpg";
import sildeimg10 from "../../../img/silde19.jpg";
import sildeimg13 from "../../../img/save21.jpg";
import sildeimg15 from "../../../img/silde20.jpg";
import sildeimg11 from "../../../img/silde18.jpg";
import sildeimg12 from "../../../img/silde17.jpg";
import tast1 from "../../../img/silde22.jpg";
import tast2 from "../../../img/test2.jpg";
import tast3 from "../../../img/test3.jpg";
import tast4 from "../../../img/test4.jpg";
import mini1 from "../../../img/silde25.jpg";
import mini2 from "../../../img/silde26.jpg";
import mini3 from "../../../img/silde27.jpg";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function SigniaHearingAids() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: false, // Hide the previous arrow
    nextArrow: false, // Hide the next arrow
  };

  var Products = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 996, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
       <Helmet>
      <title>Signia Hearing Aid Singapore</title>
        <meta name="description" content="Looking for your next hearing aid? Trust in the centuries' old innovation that's in every Signia hearing aid. Get tested at The Hearing Centre today!" />
        <meta property="og:title" content="Signia Hearing Aid Singapore"></meta>
        <meta property="og:description" content="Looking for your next hearing aid? Trust in the centuries' old innovation that's in every Signia hearing aid. Get tested at The Hearing Centre today!"></meta>
    </Helmet>
      <Header />
      <section className="phonak_hearing">
        <div className="container">
          <h1 className="Heading_text">Signia</h1>
          <p className="Heading_pergrap">
            The world’s one of the leading hearing aid brands, Signia, came into
            existence in the year 1878 (previously known as Siemens).
          </p>
        </div>
      </section>

      <section className="HearingSolutions">
        <div className="container">
          <div className="row">
            <div className="img_solution">
              <img src={phonakimg} alt="" className="img-fluid" />

              <h1>Signia: Manufacturing Hearing Aids; Developing Confidence</h1>
              <h5>
                A World-Class Hearing Aid Brand That Transforms Your Weakness
                Into Your Biggest Strength!
              </h5>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <ReactPlayer
                  height="500px"
                  url="https://www.youtube.com/embed/W7_jPpmbi04?feature=oembed&enablejsapi=1&origin=https%3A%2F%2Fwww.thehearingcentre.sg"
                  className="video_div"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Signia Hearing Aids: <br />
                  The History Behind
                </h5>
                <p>
                  The world’s one of the leading hearing aid brands, Signia,
                  came into existence in the year 1878 (previously known as
                  Siemens). With over 100 years of commitment, dedication, and
                  handwork, the Siemens-Signia company has been able to keep up
                  with the changing times and have incorporate some of the
                  latest cutting-edge hearing solutions in the hearing industry.
                  Since its conceptualization, Signia aims to transform what one
                  might perceive to be a weakness, that being hearing loss, into
                  their greatest strength. Signia brand’s motto, Be Brilliant,
                  motivates the brand to push their boundaries and produce
                  top-notch, state-of-the-art Signia hearing aids such that
                  wearers of Signia hearing aids can always Be Brilliant.
                </p>
                <p>
                  This is one of the significant reasons behind the brand’s
                  immense success is its notion to refuse hearing loss as a
                  limitation, but as a valuable opportunity to surpass the
                  hearing experience that one previously had, gaining an edge
                  over it. Being able to hear crisp, clear and profound sounds
                  helps to complete the entire package that life has to offer.
                  Signia has always leaned on the principles of improvement
                  unless the brilliance is met. And the result is, Signia is
                  pioneering the hearing aid industry with its audiologically
                  advanced solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>Signia Hearing Aid:Signia Augmented Xperience(AX)</h1>
          <h5>The Newest Ground-Breaking Signia AX Technology</h5>
          <p>
            The incorporation of the latest Signia AX technology into its Signia
            hearing aids provide one with superior and unprecedented hearing
            experiences that goes beyond previous natural-sounding solutions. As
            the first and only hearing aid in the market that utilizes two
            separate sound processors simultaneously, the ingenious use of the
            revolutionary Augmented Focus technology provide these small yet
            powerful Signia hearing aids with the capability to separate the
            sound of speech from surrounding sounds. These two sounds are then
            processed separately to provide a clear contrast, and they are then
            recombined to provide you with better speech understanding in noise
            unlike any other hearing aids.
          </p>
        </div>
      </section>

      <section className="HistoryBehind Sigin_history">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={saveimg} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Signia Hearing Aid: <br />
                  Signia Augmented Xperience (AX)
                </h5>
                <p>
                  Sounds that you are focused on appear slightly closer than in
                  reality and crisp and clear with full dynamics as they are
                  processed in a highly linear, uncompressed way with an
                  emphasis on clarity and detail, while background noises are
                  processed with a high spatial resolution and with attenuation.
                  This concept and technology is inspired by the same principle
                  as in 3D movies where key images appear directly in front of
                  you while the background remains further away. This is
                  augmented hearing provided by the latest Signia AX hearing
                  aids lets you enjoy a never-before outstanding speech clarity
                  with an amazing immersive soundscape in any situation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>Signia Hearing Aid: Signia Xperience (X)</h1>
          <h5>Committed To Giving A Never-Before Hearing Experience</h5>
          <p>
            Committed to making all Signia hearing aids wearers Be Brilliant,
            the Siemens-Signia company has managed to launch a new collection of
            Signia hearing aids, known as the Signia Xperience hearing aids,
            which will revolutionize the global hearing aid industry. Signia
            Xperience is a new platform that introduces the world’s first
            combination of acoustic sensors with a built-in motion sensor.
            Signia Xperience aims to ensure that Signia hearing aids wearers can
            be fully involved in their daily activities, without any
            restrictions from hearing loss. With its comprehensive YourSound
            technology, Signia Xperience delivers superior and unique sound
            processing driven by built-in acoustic-motion sensors. Together with
            the extensive range of channels installed in Signia hearing aids to
            receive different sound frequencies, YourSound technology helps to
            capture more aspects of sound than ever before, even during
            movements conducted by Signia hearing aids wearers, so that anyone
            can hear what matters to them most, be it conversations or
            surrounding noises, anytime and anywhere. To add on, it has been
            statistically proven from 90% of the Signia hearing aids wearers
            that the Signia hearing aids can deliver natural sound experience,
            as well as maximize both speech understanding ability and hearing
            efficiency while stationary and in motion. Moreover, with the
            features of dynamic soundscape processing and own voice processing
            installed together with YourSound technology, Signia hearing aids
            utilizes in-depth understanding about their wearer’s individual
            hearing environments and preferences to deliver personalized sound
            accurately and precisely, such that it can mimic the sounds of
            nature. This will further strengthen the Signia Xperience that the
            Siemens-Signia company aims to provide for Signia hearing aids
            wearers and assure their well-being, without any compromise. Keen to
            see the diverse collection of small, yet powerful Signia Xperience
            hearing aids that we provide here in The Hearing Center? Let’s dive
            in!
          </p>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={save6img} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Signia Hearing Aid: <br />
                  Signia Active Pro X
                </h5>
                <p>
                  Iconic user-friendly Signia in-the-ear (ITE) hearing aid
                  design that mimics the comfort and trendy styles of modern
                  premium bluetooth earbuds, while incorporating the most
                  advanced audiological technology to provide first-class,
                  on-the-go and true-to-life hearing experiences. Through the
                  newly innovated Signia Xperience YourSound technology built on
                  acoustic-motion sensors, this enables the latest Signia
                  hearing aids to deliver enhanced speech understanding,
                  brilliant audiological performances and automatic situations
                  detection that cater to all active acoustic lifestyles. The
                  combination of personally tailored sound, through the use of
                  an installed AI voice assistant, along with the most popular
                  and trendiest earbud design has made these Signia hearing aids
                  well-liked by at least 2 out of every 3 people in the hearing
                  aids market. With pocket-sized Signia Active Pro charging
                  case, these Signia hearing aids are rechargeable and enables
                  anyone to use their Signia digital hearing aids flexibly,
                  anywhere and anytime for up to 26 hours per charge. Bluetooth
                  connectivity to smartphones, TV and other electronic devices
                  enables high quality streaming of audio directly to Signia
                  hearing aids. Moreover, these Signia hearing aids are always
                  ready to wear and can snuggle every ear with perfect precision
                  and ultimate comfort.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="KeyFeatures">
        <div className="container">
          <h1 className="Heading_text">Signia AX Hearing Aids: Key Features</h1>
          <div className="silder_div">
            <Slider {...Products}>
              <div>
                <div class="card">
                  <img src={sildeimg1} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Automatic Situation Detection</h6>
                    <p class="card-text">
                      Advanced sensor technology that provides you with the best
                      possible sounds and clear understanding of speech from any
                      direction throughout the day by automatically analyzing
                      and adapting to the acoustic and motion changes
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="card">
                  <img src={sildeimg2} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Immersive Soundscape </h6>
                    <p class="card-text">
                      The use of two separate processors: one for sounds in
                      focus, like your conversation partner’s voice, and the
                      other for surroundings
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg3} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">AI Digital Assistant </h6>
                    <p class="card-text">
                      Signia Assistant offers you immediate support whenever
                      there is a need for adjustments of settings
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg4} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Android & iPhone Connectivity </h6>
                    <p class="card-text">
                      Direct streaming for both iOS and ASHA-compatible Android
                      smartphone with for calls and music clearer and quality
                      sounds as well as advanced tinnitus therapies, along with
                      the use of Signia App and Signia Assistant
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="card">
                  <img src={sildeimg5} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Recharge On-The-Go </h6>
                    <p class="card-text">
                      Portable charging with ultimate convenience, providing you
                      with up to 36 hours of use on a single charge with 5 hours
                      of streaming
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg6} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Augmented Speech Understanding </h6>
                    <p class="card-text">
                      Listen to conversations with your partners with
                      outstanding speech clarity in an immersive environment
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg7} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Own Voice Processing </h6>
                    <p class="card-text">
                      Separates the wearer’s own voice from other speech and
                      noise for a natural sound, keeping you engaged in
                      conversations
                    </p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row flex-column-reverse flex-lg-row ">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Signia Hearing Aid: <br />
                  Signia Styletto X
                </h5>
                <p>
                  These Signia Styletto X hearing aids are the world’s first
                  SLIM-RIC (receiver-in-canal) hearing aids that provide clear
                  sound and speech understanding even in active situations,
                  while revolutionizing the aesthetics of hearing aids with its
                  brilliant award-winning designs. Its uniquely refined
                  slim-line design has been statistically proven to be preferred
                  by 8 out of 10 people as opposed to the normal hearing aids
                  designs. This attractive design will therefore definitely
                  entice and attract both old and new hearing aids wearers of
                  all generations. Incorporation of Signia Xperience technology
                  with the world’s first acoustic-motion sensors allow defined
                  and rich speech comprehension in any environments, including
                  those that are noisy and even during engagement of physical
                  activities. The availability of static noise tinnitus therapy
                  and ocean wave tinnitus therapy help to divert the attention
                  of its wearers away from the disturbing tinnitus sounds with
                  personalized counteractive soothing and therapeutic sounds, as
                  well as in-built Notch therapy to help mask tonal tinnitus and
                  may even completely eliminate tinnitus problems. Bluetooth
                  connectivity to smartphones, TV and other electronic devices
                  enables high quality streaming of audio directly to Signia
                  hearing aids. Being remotely controllable through the use of
                  Signia Assistant installed in the Signia hearing aids, this
                  allow its wearers to adjust to any environments at anytime.
                  With the creation of the latest pocket-sized charger case
                  using Qi wireless technology, this enables anyone to charge
                  and use their Signia digital hearing aids flexibly, anywhere
                  and anytime for up to 3 days.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg9} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg12} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Signia Hearing Aid: <br />
                  Signia Pure Charge&Go X
                </h5>
                <p>
                  Signia Pure Charge&Go X hearing aids are the latest ultimate
                  rechargeable receiver-in-canal (RIC) hearing aids that
                  amalgamates all the advanced features that Signia Xperience
                  has to offer, along with Li-ion rechargeability and Bluetooth
                  connectivity. Moreover, with increased battery capacity by
                  20%, these small and compact Signia hearing aids are able to
                  provide the best wearer’s satisfaction when it comes to
                  long-lived battery lifespan and Bluetooth streaming of high
                  quality audio. These hearing aids are truly Pure Charge&Go.
                  Incorporation of Signia Xperience technology with the world’s
                  first acoustic-motion sensors for automatic situation
                  detection, as well as defined and rich speech comprehension in
                  any environments, including those that are noisy or even
                  during engagement of physical activities. With the utilization
                  of Li-ion charging technology, these Signia hearing aids are
                  rechargeable, thus enabling anyone to use their Signia digital
                  hearing aids flexibly, anywhere and anytime. Being equipped
                  with ultra HD e2e and long-lasting Bluetooth connectivity to
                  smartphones, TV and other electronic devices, these features
                  enable high quality streaming of audio directly to Signia
                  hearing aids. Moreover, there is a wide range of performance
                  levels available for these Signia hearing aids, which can
                  cater to the wearer’s needs and concerns. These Signia Pure
                  Charge&Go X will surely bring crystal-clear sound straight to
                  your ears as it is tailored specifically to fit your needs.
                </p>
              </div>
            </div>
          </div>

          <div className="menu_new">
            <h6>Some of the key advantages of Pure Charge&Go includes:</h6>
            <ul>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Bringing the ultimate charging abilities to the desk
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp; Understanding your environment and filters sound that’s
                not important to be heard by you
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Bluetooth connectivity to stream calls and music
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>Signia Hearing Aid: Signia CROS X</h1>
          <h5>
            The Ultimate Portfolio Of CROS Devices In The Hearing Industry
          </h5>
          <p>
            Signia’s latest CROS hearing aids provide the ultimate choice of
            styles and fittings for people with unaidable hearing loss in one
            ear. From the world’s only ready-to-wear in-the-ear CROS devices to
            convenient lithium-ion charging and Bluetooth connectivity, there is
            a suitable solution for everyone out there.
          </p>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Signia Hearing Aid: <br />
                  Signia Silk X
                </h5>
                <p>
                  Through customization, these small, ultra-discreet
                  completely-in-canal (CIC) Signia hearing aids provide instant
                  perfect fit into its wearer’s ears and ultimate comfort, while
                  incorporating Signia Xperience platforms to deliver enhanced
                  speech understanding. These Signia hearing aids are
                  tailor-made to suit each individual ear with perfect fit and
                  absolute discretion. They are equipped with highly adaptable
                  soft-silicone click sleeves to ensure ultimate comfort and
                  strong retention capabilities in the wearer’s ears and prevent
                  these Signia hearing aids from falling out, especially during
                  intensive activities. The click sleeves also come in various
                  forms and sizes to expand the range of suitability for most
                  ear anatomies and audiological needs. With the Integration of
                  Binaural OneMic Directionality feature, along with Dynamic
                  Soundscape Processing of Signia Xperience that minimizes
                  background noises, this allows the Signia hearing aids to
                  highlight and capture precise speech in any difficult
                  situations. Don’t try to compare its discreet size with its
                  capabilities! Although it’s small in size, gives the most
                  natural hearing experience a hearing aid can ever give!
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg11} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="menu_new">
            <h6>some of the key advantages Of Signia Silk X includes:</h6>
            <ul>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Excellent sound quality
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp; Fits in the ear just perfectly
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Do not reveal your hearing impairment due to its small
                size
              </li>
            </ul>
          </div>

          <div className="menu_new">
            <h6>Some of the key features of Signia Silk X includes:</h6>
            <ul>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;20% smaller in size as compared to its predecessors
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp; Red and blue color codes to distinguish the hearing aids
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Ultra HD E2E for superior wireless binaural processing
              </li>

              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Silicone click sleeves for a precise fit
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg10} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Signia Hearing Aid: <br />
                  Signia Motion Charge&Go X
                </h5>
                <p>
                  These small and lustrous behind-the-ear (BTE) Signia hearing
                  aids help to reflect the comprehensiveness of our buzzling and
                  hustling modern lives such that its wearers can adapt to every
                  move with excellent sound quality. Incorporation of Signia
                  Xperience technology with the world’s first acoustic-motion
                  sensors allows for automatic situation detection, as well as
                  defined and rich speech comprehension in any environments,
                  including those that are noisy and even during engagement of
                  physical activities. With the utilization of Li-ion charging
                  technology, these Signia hearing aids are rechargeable, thus
                  enabling anyone to use their Signia digital hearing aids
                  flexibly, anywhere and anytime for up to 61 hours per charge.
                  Bluetooth connectivity to smartphones, TV and other electronic
                  devices enables high quality streaming of audio directly to
                  Signia hearing aids. Since it is remotely controllable through
                  the use of Signia Assistant installed in the Signia hearing
                  aids, this allows its wearers to adjust to any environments at
                  anytime. Moreover, these Signia hearing aids have the latest
                  small and sleek design, which provides Super Fit, along with
                  Super Power and Super Features.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Signia Hearing Aid: <br />
                  Signia Pure 312 X
                </h5>
                <p>
                  Signia Pure 312 X hearing aids are not only elegantly slim and
                  discreet, these receiver-in-canal (RIC) hearing aids are also
                  able to incorporate all the advanced features of the Signia
                  Xperience technology and excellent bluetooth connectivity.
                  Moreover, telecoils can also be connected to these Signia
                  hearing aids to facilitate the hearing and speech
                  understanding. The incorporation of Signia Xperience
                  technology with the world’s first acoustic-motion sensors
                  allows for automatic situation detection, as well as natural
                  voice and clear speech comprehension in any environments,
                  including those that are noisy and even during engagement of
                  physical activities. There are also optional integrated
                  telecoils available to enhance the Signia Xperience. To keep
                  up to trend, these Signia hearing aids are equipped with ultra
                  HD ear-2-ear (e2e) and long-lasting bluetooth connectivity to
                  smartphones, TV and other electronic devices to enable high
                  quality streaming of audio directly to Signia hearing aids.
                  Moreover, there is a wide range of performance levels
                  available, to suit each and every wearer’s needs and concerns.
                  If you want to go unnoticed about your hearing disability,
                  Signia’s Pure 312 X is the solution for you. Its small size
                  would not let your loss be the hurdle in your life. it is the
                  smallest yet most effective hearing aid for a tailored hearing
                  experience.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg15} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="menu_new">
            <h6>Some of the key advantages Of Pure 312 X includes:</h6>
            <ul>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Bluetooth connectivity
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp; Highly comfortable
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="Paradise_Hearing_Aids  CROS">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card_hearing">
                <h5>Signia Hearing Aid: Signia CROS X</h5>
                <div className="silder">
                  <Slider {...settings}>
                    <div>
                      <div class="card">
                        <img src={sildeimg13} class="card-img-top" alt="..." />
                        <div class="card-body">
                          <h6 class="card-title">Signia CROS Pure 312 X </h6>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="card">
                        <img src={save4img} class="card-img-top" alt="..." />
                        <div class="card-body">
                          <h6 class="card-title">Signia CROS Silk X </h6>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="card">
                        <img src={tast1} class="card-img-top" alt="..." />
                        <div class="card-body">
                          <h6 class="card-title">
                            Signia CROS Pure Charge&Go X{" "}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="card_hearing2">
                <h5>Signia Hearing Aid: Signia CROS X</h5>
                <div className="silder">
                  <div class="card">
                    <div class="card-body">
                      <p class="card-text">
                        The Siemens-Signia company has successfully transformed
                        and innovated the most powerful collection of CROS
                        hearing aids in the hearing aids industry. This
                        collection of Signia CROS hearing aids will most
                        absolutely entice wearers with severe to profound
                        hearing loss on one ear, also known as single-sided
                        deafness (SSD) or unilateral deafness.
                      </p>
                      <p class="card-text">
                        CROS stands for Contralateral Routing of Signals. With
                        Signia CROS system, the wearers will have to wear Signia
                        CROS hearing aids on both ears such that the sound
                        detected by the wireless transmitter in the Signia CROS
                        hearing aid on the unadiable ear is directly transmitted
                        to the receiver in the Signia CROS hearing aid on the
                        other ear. This will reduce the “head shadow” effect and
                        facilitate the equal transmission of sound from one ear
                        to both sides of the brain. With the Signia CROS X
                        hearing technology, hearing everything and everyone in
                        crystal-clear and with ease quality is made possible
                        again, regardless of which side the conversations and
                        sounds are coming from.
                      </p>
                      <p class="card-text">
                        In the Siemens-Signia company, this collection of Signia
                        CROS X hearing aids consist of Signia CROS Pure
                        Charge&Go X, Signia CROS Pure 312 X and Signia CROS Silk
                        X hearing aids.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <section className="AidLumity">
        <div className="container">
          <h1>Signia Hearing Aid: Hearing Accessories</h1>
          {/* <h5>The Only Pediatric Hearing Aids In The Market</h5> */}
          <p>
            Signia also provides a range of hearing accessories that can be
            paired wirelessly to your Signia hearing aids via Bluetooth
            connectivity. From accessories that provides remote control to
            change your Signia hearing aid settings remotely, to accessories
            that allows for audio direct streaming, Signia’s broad range of
            practical and easy-to-use accessories enhances your hearing
            experience and makes every day life easier
          </p>
        </div>
      </section>

      <section className="Audeo_section ChargingOptions">
        <div className="container">
          <h1 className="Heading_text">
            Signia Hearing Aid: Hearing Accessories
            <hr />
          </h1>

          <div className="row">
            <div className="col-md-4">
              <div class="card">
                <img src={mini1} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Signia StreamLine TV </h5>
                  <p class="card-text">
                    The Signia StreamLine TV directly feeds your TV audio in
                    Dolby Digital quality into your Signia hearing aids. Volume
                    adjustment can be done individually via the Signia App,
                    therefore offering a fully automatic and intuitive wireless
                    hearing experience. The Streamline TV also enables direct
                    streaming into multiple pairs of compatible Signia hearing
                    aids at the same time, this allow one to enjoy watching TV
                    with their friends and family.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={mini2} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Signia StreamLine Mic </h5>
                  <p class="card-text">
                    With the connection of your Signia hearing aids and the
                    Signia StreamLine Mic, enjoy an 4-in-1 listening experience!
                    Your Signia hearing aids becomes much more convenient and
                    functional as it becomes a hands-free mobile headset for the
                    streaming of phone calls, a wireless headphones that streams
                    premium stereo quality audio from any Bluetooth enabled
                    devices. The StreamLine Mic also functions as a remote
                    control that boost speech understanding in the most
                    challenging situations to assist hearing by streaming a
                    speaker’s voice directly into your hearing aids from a
                    distance up to 20 metres. With the Signia app, you can also
                    control your StreamLine Mic for maximum convenience.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={mini3} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Signia miniPocket </h5>
                  <p class="card-text">
                    The ideal solution for anyone who wants discreet, convenient
                    control of their hearing aids without the need for a large
                    remote control or smartphone. Reliable and easy to use, the
                    miniPocket is small enough to carry on a key ring yet
                    powerful enough to control all essential features.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
